import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tag } from "antd";
import CardSkeleton from "components/CardSkeleton";
import { useEffect, useState, useRef } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Row,
  Table,
  Label,
} from "reactstrap";
import Select from "react-select";
import swal from "sweetalert";
import {
  useUpdateFarmByIdMutation,
  useCreateCropDetailsMutation,
  useUpdateCropDetailsMutation,
} from "./farmerApiSlice";
import FarmerCreateBoundary from "./FarmerCreateBoundary";
import FarmerCropDynamicData from "./FarmerCropDynamicData";
import FarmerCropHealthMap from "./FarmerCropHealthMap";
import FarmerLandNoResponse from "./FarmerLandNoResponse";
import CustomTextField from "components/CustomTextField";
import { usePDF } from "react-to-pdf";
import { useGetCropListQuery } from "features/dashboard/RiskManagement/RiskManagementApiSlice";
import jsPDF from "jspdf";
import domtoimage from "dom-to-image-more";
import { Divider } from "@mui/material";
const FarmerDetailsLand = ({
  tabIndex,
  data,
  refetch,
  isLoading,
  RoleAcessParams,
  idd,
}) => {
  const { id } = useParams();
  const [LandList, setLandList] = useState([]);
  const [allData, setWholeData] = useState([]);
  const [showCrop, setShowCrop] = useState(false);
  const [cropList, setCropList] = useState([]);
  const [openCreateBoundary, setCreateBoundary] = useState(false);
  const [cropHealthModal, setCropHealthModal] = useState(false);
  const [SendPlotData, setSendPlotData] = useState([]);
  const [plotDetails, setPlotLandData] = useState([]);
  const [showCropDetailsData, setCropDetailsData] = useState(false);
  const [loading, setLoader] = useState(false);
  const [loadingg, setLoading] = useState(false);
  const [CropCode, setCropCode] = useState({});
  const [CropImg, setCropImg] = useState({});
  const [edit, setEdit] = useState(false);
  const [CropLabel, setCropLabel] = useState({});
  // const { data: data, refetch } = useGetFarmerByIdQuery(id);
  const [updateFarm] = useUpdateFarmByIdMutation();
  const [updateCrop] = useCreateCropDetailsMutation();
  const [updateCropPatch] = useUpdateCropDetailsMutation();
  const mapRef = useRef(null);
  const { data: getCropData } = useGetCropListQuery();
  const [CropListMaster, setCropMasterList] = useState([]);
  const [analyticsmodal, setShowAnanlyticsModal] = useState(false);
  const [currentStatus, setCurrentStatus] = useState("");
  const [showLoader, setLoaderMain] = useState(false);
  const [cropDetailModal, setCropDetailModal] = useState(false);
  const [modaltype, setModalType] = useState("");
  const [addCrop, setAddCrop] = useState(false);
  const { toPDF, targetRef } = usePDF({ filename: "Farm Details.pdf" });
  const [activeCard, setActiveCard] = useState("currentReport");

  const [Group, editGroup] = useState({
    year: "",
    sowing_date: "",
    season: "",
    harvest_date: "",
    crop_yield: "",
  });
  useEffect(() => {
    //  refetch()
    const userFromApi = data?.data ? data?.data : LandList;
    if (userFromApi.farm !== undefined) setLandList(userFromApi.farm);
  }, [tabIndex]);
  useEffect(() => {
    setCropMasterList(getCropData?.data?.results);
  }, [getCropData]);
  useEffect(() => {
    if (data != undefined) {
      setWholeData(data?.data);
      setLandList(data?.data?.farm);
    }
  }, [data]);
  // const handleDownload = async () => {
  //   setLoading(true);
  //   await toPDF();
  //   setLoading(false);
  // };
  const handleDownload = async () => {
    setLoading(true);
    setTimeout(async () => {
      await toPDF();
      setLoading(false);
    }, 1000);
  };

  // const AddCropDetails = (landData, type) => {
  //   setAddCrop(!addCrop);
  //   setCropList(landData);
  // };
  const AddCropDetails = (landData, type, cropData = null) => {
    setAddCrop(true);
    setCropList(landData);
    if (type === "edit" && cropData) {
      editGroup({
        season: cropData.season,
        year: cropData.year,
        picking_type: cropData.picking_type || "",
        sowing_date: cropData.sowing_date || "",
        harvest_date: cropData.harvest_date || "",
        crop_yield: cropData.crop_yield || "",
        income: cropData.income || "",
      });
      setCropCode(cropData.crop_code);
      setCropLabel(cropData.crop_name);
      setCropImg(cropData.crop_image);
      setEdit(true);
    } else {
      editGroup({
        season: "",
        year: "",
        picking_type: "",
        sowing_date: "",
        harvest_date: "",
        crop_yield: "",
        income: "",
      });
      setEdit(false);
    }
  };

  const showCropDetails = (landData, type) => {
    if (type === "mobile") {
      setCropDetailModal(true);
    } else {
      setShowCrop(!showCrop);
    }
    setCropList(landData);
  };
  const OpenCreateBoundaryPopup = (landData) => {
    setCreateBoundary(true);
    setSendPlotData(landData);
  };
  const handleClose = () => {
    setCreateBoundary(false);
  };
  const OpenCropHealth = (landData, type) => {
    setModalType(type);
    setCropHealthModal(true);
    setTimeout(() => {
      setPlotLandData(landData);
      setCropDetailsData(true);
      setLoader(false);
      // if (type !== "mobile") {
      //   window.scrollTo({
      //     top: document.documentElement.scrollHeight,
      //     behavior: "smooth",
      //   });
      // }
    }, 1500);
    setLoader(true);
  };

  const RegenerateACS = (landData) => {
    var flippedCoordinates = JSON.parse(
      JSON.stringify(landData?.boundary?.coordinates)
    );
    // flippedCoordinates[0].map((item) => item.reverse());
    let payload = {
      coordinates: flippedCoordinates,
    };
    updateFarm({ id: landData.id, payload: payload })
      .unwrap()
      .then((data) => {
        swal("It will take 15-20 minutes to regenerate ACS", {
          buttons: false,
          icon: "success",
          title: "Generating Farm Report",
          timer: 4500,
        });
        refetch();
      })
      .catch((error) => {
        toast.error("Error while Regenerating ACS");
        return;
      });
  };
  const ReloadApplication = () => {
    setLoaderMain(true);
    setTimeout(() => {
      refetch();
      setLoaderMain(false);
    }, 1500);
  };
  const showAnalyticsModal = (data) => {
    setShowAnanlyticsModal(true);
    setCurrentStatus(data.analytics_task_status);
  };
  const handleCloseAnalytics = () => {
    setShowAnanlyticsModal(false);
    setCurrentStatus("");
  };
  const onInputChange = (event) => {
    const { name, type, files, value } = event.target;
    if (type === "file") {
      editGroup({
        ...Group,
        [name]: event.target.files[0],
      });
    } else {
      editGroup({
        ...Group,
        [name]: value,
      });
    }
  };

  const optionCrop = [
    {
      label: "Crop",
      options: CropListMaster?.map((crop) => ({
        label: `${crop.crop_name}`,
        value: `${crop.id}`,
        img: `${crop.image_path}`,
      })),
    },
  ];
  const handleCropCode = (CropCode, CropLabel, CropImg) => {
    setCropCode(CropCode);
    setCropLabel(CropLabel);
    setCropImg(CropImg);
  };
  const handleAddCrop = (e) => {
    e.preventDefault();
    let formData = {
      ...Group,
      crop_code: CropCode,
      crop_name: CropLabel,
      plot_id: cropList.id,
      crop_image: CropImg,
    };
    if (!edit) {
      setLoading(true);
      updateCrop({ id, formData })
        .unwrap()
        .then((data) => {
          setLoading(false);
          setAddCrop(false);
          swal("Crop Details Added", {
            buttons: false,
            icon: "success",
            title: "Added",
            timer: 4500,
          });
          refetch();
        })
        .catch((error) => {
          toast.error("Error while Creating Crop");
          setLoading(false);
          return;
        });
    } else {
      setLoading(true);
      updateCropPatch({ id, formData })
        .unwrap()
        .then((data) => {
          setLoading(false);
          setAddCrop(false);
          swal("Crop Details Updated", {
            buttons: false,
            icon: "success",
            title: "Added",
            timer: 4500,
          });
          refetch();
        })
        .catch((error) => {
          toast.error("Error while Creating Crop");
          setLoading(false);
          return;
        });
    }
  };
  const handleDownloadPDF = async () => {
    if (!mapRef.current) return;
    setLoading(true);
    setTimeout(async () => {
      try {
        const imgData = await domtoimage.toPng(mapRef.current, {
          useCORS: true,
          bgcolor: "#fff",
          filter: (node) => {
            if (
              node.tagName === "LINK" &&
              node.href &&
              !node.href.startsWith(window.location.origin)
            ) {
              return false;
            }
            return true;
          },
        });

        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "px",
          format: [mapRef.current.scrollWidth, mapRef.current.scrollHeight],
        });

        pdf.addImage(
          imgData,
          "PNG",
          0,
          0,
          mapRef.current.scrollWidth,
          mapRef.current.scrollHeight
        );
        pdf.save("Farm Report.pdf");
        // allData?.full_name
      } catch (error) {
        console.error("Error capturing map as PDF:", error);
      } finally {
        setLoading(false);
      }
    }, 1000);
  };

  return (
    <Card className="globalboxshadow">
      <div className="page-content col-12 ">
        <div className="border-lg transparent_card">
          <div
            className="d-flex justify-content-between  align-items-center "
            style={{ borderRadius: "5px", backgroundColor: "#f1f1f1" }}
          >
            <div className="heading-title mt-lg-0 mt-2 py-3">
              <h5
                className="mx-4"
                style={{
                  fontSize: "18px",
                  color: "black",
                }}
              >
                <i
                  className="mdi mdi-account-hard-hat me-2"
                  style={{ fontSize: "1.5rem" }}
                ></i>
                {allData?.full_name}
              </h5>
            </div>
            <div
              className="d-flex justify-content-end align-items-center flex-wrap"
              style={{ gap: "6px" }}
            >
              <Button
                className="bg-transparent text-black fs-6 reloadButton me-2"
                size="sm"
                onClick={ReloadApplication}
              >
                Reload <FontAwesomeIcon icon={faRotateLeft} />
              </Button>
            </div>
          </div>
          {showLoader ? (
            <CardSkeleton />
          ) : (
            <div className="border-lg rounded transparent_card">
              <div className="p-0 ">
                <>
                  <div
                    className=" table-responsive d-lg-block d-md-none d-none text-gray"
                    id="familyid"
                  >
                    {LandList.length > 0 ? (
                      <>
                        {LandList?.map((landData, index) => (
                          <div className="row mb-4 mt-4 mx-2" key={index}>
                            <div className="col-lg-8">
                              <Card className="shadow-sm border-0">
                                <CardHeader
                                  className="d-flex justify-content-between align-items-center flex-wrap gap-2 px-3 py-2"
                                  style={{ background: "white" }}
                                  // style={{ background: "linear-gradient(to right, #f0fff4, #d9fddc)" }}
                                >
                                  <div className="d-flex align-items-center gap-2">
                                    <i className="mdi mdi-home-analytics fs-5 text-success"></i>
                                    <h5 className="m-0 fw-semibold text-dark">
                                      Farm Details
                                    </h5>
                                  </div>

                                  <div className="d-flex flex-wrap gap-2">
                                    <button
                                      className="btn btn-sm btn-success text-white"
                                      onClick={() =>
                                        AddCropDetails(
                                          landData,
                                          "notEdit",
                                          index
                                        )
                                      }
                                    >
                                      <i className="mdi mdi-plus-circle-outline me-1"></i>
                                      Add Crop
                                    </button>

                                    {landData?.boundary_updated ? (
                                      <>
                                        <button
                                          className="btn btn-sm btn-primary text-gray"
                                          onClick={() =>
                                            OpenCropHealth(landData, "desktop")
                                          }
                                        >
                                          <i className="mdi mdi-file-chart-outline me-1"></i>
                                          View Report
                                        </button>

                                        <button
                                          className="btn btn-sm btn-secondary text-white"
                                          onClick={() =>
                                            landData?.is_analytics_task_active
                                              ? showAnalyticsModal(landData)
                                              : RegenerateACS(landData)
                                          }
                                        >
                                          <i className="mdi mdi-sync me-1"></i>
                                          Generate Report
                                        </button>
                                      </>
                                    ) : (
                                      <button
                                        className="btn btn-sm btn-warning text-white"
                                        onClick={() =>
                                          OpenCreateBoundaryPopup(landData)
                                        }
                                      >
                                        <i className="mdi mdi-map-marker-plus-outline me-1"></i>
                                        Create Boundary
                                      </button>
                                    )}
                                  </div>
                                </CardHeader>

                                <CardBody className="p-4">
                                  {/* Farm Table */}
                                  <div className="d-lg-block d-md-block d-none mb-4">
                                    <Table
                                      className="table mb-0"
                                      hover
                                      responsive
                                    >
                                      <tbody>
                                        <tr>
                                          <th>Plot Name:</th>
                                          <td>
                                            {landData?.plot_name || "N/A"}
                                          </td>
                                          <th className="ps-4">Land Mark:</th>
                                          <td>
                                            {landData?.land_mark || "N/A"}
                                          </td>
                                        </tr>
                                        {/* <tr>
                                          <th>Survey Number:</th>
                                          <td>
                                            {landData?.survey_number || "N/A"}
                                          </td>
                                          <th className="ps-4">
                                            Declared Area:
                                          </th>
                                          <td>
                                            {landData?.declared_area || "N/A"}
                                          </td>
                                        </tr> */}
                                        <tr>
                                          <th>Calculated Area:</th>
                                          <td>
                                            {landData?.calculated_area || "N/A"}
                                          </td>
                                          <th className="ps-4">
                                            {RoleAcessParams?.includes("HCL")
                                              ? "Farm Score:"
                                              : "ACS:"}
                                          </th>
                                          <td>{landData?.ACS || "N/A"}</td>
                                        </tr>
                                        <tr>
                                          <th>Crop Health:</th>
                                          <td>
                                            {landData?.crop_health || "N/A"}
                                          </td>
                                          <th className="ps-4">
                                            Cropping Pattern:
                                          </th>
                                          <td>
                                            {landData?.cropping_pattern ||
                                              "N/A"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Survey Number:</th>
                                          <td>
                                            {landData?.survey_number || "N/A"}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </div>

                                  {/* Crop Details Section */}
                                  <div className="mt-4">
                                    <h6 className="m-0 fw-semibold text-dark d-flex align-items-center gap-1 mb-3">
                                      <i className="mdi mdi-sprout text-success fs-5"></i>
                                      Crop Details
                                    </h6>

                                    {landData.crops.length > 0 ? (
                                      <div className="d-flex flex-wrap gap-3">
                                        {landData.crops.map((item, i) => {
                                          const bgColors = [
                                            "#E3F9E5",
                                            "#FFF3E0",
                                            "#E1F0FF",
                                            "#FDE2E2",
                                            "#FFF8E1",
                                          ];
                                          const bgColor =
                                            bgColors[i % bgColors.length];

                                          return (
                                            <div
                                              key={i}
                                              className="rounded p-3 border shadow-sm d-flex align-items-center"
                                              style={{
                                                fontSize: "0.85rem",
                                                backgroundColor: bgColor,
                                                width: "100%",
                                              }}
                                            >
                                              <img
                                                src={item.crop_image}
                                                alt="crop"
                                                className="rounded-circle border"
                                                style={{
                                                  height: "40px",
                                                  width: "40px",
                                                  objectFit: "cover",
                                                  backgroundColor: "#f0f0f0",
                                                  flexShrink: 0,
                                                }}
                                              />
                                              <div className="ms-3 flex-grow-1">
                                                <div className="fw-semibold text-dark">
                                                  {item.crop_name}
                                                  <span
                                                    className="text-muted mx-5"
                                                    style={{
                                                      fontSize: "0.75rem",
                                                    }}
                                                  >
                                                    {item.season} ({item.year})
                                                  </span>
                                                </div>
                                              </div>

                                              <div
                                                className="d-flex text-muted"
                                                style={{
                                                  fontSize: "0.75rem",
                                                  gap: "1.5rem",
                                                  minWidth: "220px",
                                                  justifyContent: "flex-start",
                                                }}
                                              >
                                                <div className="d-flex align-items-center">
                                                  <i className="mdi mdi-calendar-start me-1 text-warning"></i>
                                                  <span>
                                                    Yield : {item.crop_yield}
                                                  </span>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                  <i className="mdi mdi-calendar-start me-1 text-warning"></i>
                                                  <span>
                                                    Sowing : {item.sowing_date}
                                                  </span>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                  <i className="mdi mdi-calendar-end me-1 text-success"></i>
                                                  <span>
                                                    Harvest :{" "}
                                                    {item.harvest_date}
                                                  </span>
                                                </div>
                                              </div>

                                              {/* <i
                                                className="mdi mdi-pencil fs-5 text-primary cursor-pointer ms-3"
                                                onClick={() =>
                                                  AddCropDetails(
                                                    landData,
                                                    "edit",
                                                    item
                                                  )
                                                }
                                                title="Edit Crop"
                                                style={{ flexShrink: 0 }}
                                              ></i> */}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    ) : (
                                      <div
                                        className="text-center p-3 border rounded text-muted mt-2"
                                        style={{
                                          background: "#f5fdf8",
                                          fontSize: "0.75rem",
                                        }}
                                      >
                                        <i className="mdi mdi-seed-outline fs-3 mb-2 text-success"></i>
                                        <div className="fw-semibold">
                                          No Crop Data
                                        </div>
                                        <div className="small">
                                          Click "Add Crop" above to enter
                                          details
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </CardBody>
                              </Card>
                            </div>

                            {/* FARM MAP CARD */}
                            <div className="col-lg-4">
                              <Card className="shadow-sm border-0">
                                <CardHeader
                                  className="d-flex align-items-center gap-2 px-3 py-2"
                                  style={{ background: "white" }}
                                  // style={{ background: "linear-gradient(to right, #e0f7fa, #cdeef3)" }}
                                >
                                  <i className="mdi mdi-map fs-5 text-info"></i>
                                  <h5 className="m-0 fw-semibold text-dark">
                                    Farm Map
                                  </h5>
                                </CardHeader>
                                <CardBody className="p-2">
                                  <FarmerCropHealthMap
                                    boundary={landData?.boundary}
                                    acs={landData?.summary_stats?.acs}
                                    height="46vh"
                                    boundaryUpdated={landData.boundary_updated}
                                    latLong={[
                                      landData?.latitude_1,
                                      landData?.longitude_1,
                                    ]}
                                  />
                                </CardBody>
                              </Card>
                            </div>
                            <Divider style={{ borderColor: "#dee2e6" }} />
                            <Divider style={{ borderColor: "#dee2e6" }} />
                          </div>
                        ))}
                      </>
                    ) : (
                      <FarmerLandNoResponse />
                    )}

                    <div className="d-flex flex-lg-row flex-md-row flex-wrap mt-2 d-lg-none d-md-block d-block">
                      {isLoading ? (
                        <CardSkeleton />
                      ) : LandList.length > 0 ? (
                        LandList.map((landData, index) => (
                          <div
                            className="card mb-3 col-lg-3 col-md-6 col-12 shadow-sm rounded-3 custom-hover-effect"
                            key={index}
                          >
                            <div className="card-body p-3 fpo_card position-relative">
                              <div className="d-flex flex-column gap-2">
                                <div className="d-flex justify-content-between">
                                  <h5 className="text-success m-0 text-capitalize">
                                    {landData.land_mark || "N/A"}
                                  </h5>
                                </div>

                                <div className="d-flex justify-content-between">
                                  <h6 style={{ color: "#5c5c5cb3" }}>ACS:</h6>
                                  <span>{landData.ACS || "N/A"}</span>
                                </div>

                                <div className="d-flex justify-content-between">
                                  <h6 style={{ color: "#5c5c5cb3" }}>
                                    Survey No.:
                                  </h6>
                                  <span>{landData.survey_number || "N/A"}</span>
                                </div>

                                <div className="d-flex justify-content-between">
                                  <h6 style={{ color: "#5c5c5cb3" }}>
                                    Declared Area:
                                  </h6>
                                  <span>{landData.declared_area || "N/A"}</span>
                                </div>

                                <div className="d-flex justify-content-between">
                                  <h6 style={{ color: "#5c5c5cb3" }}>
                                    Calculated Area:
                                  </h6>
                                  <span>
                                    {landData.calculated_area || "N/A"}
                                  </span>
                                </div>

                                <div className="d-flex justify-content-between">
                                  <h6 style={{ color: "#5c5c5cb3" }}>
                                    Irrigation Source:
                                  </h6>
                                  <span>
                                    {landData.irrigation_source || "N/A"}
                                  </span>
                                </div>

                                <div className="d-flex justify-content-between">
                                  <h6 style={{ color: "#5c5c5cb3" }}>
                                    Analytics Status:
                                  </h6>

                                  <Tag
                                    bordered={false}
                                    style={{ fontWeight: "500" }}
                                    color="geekblue"
                                  >
                                    {landData.analytics_task_status || "N/A"}
                                  </Tag>
                                </div>

                                <div className="d-flex justify-content-between mt-2">
                                  {landData?.crops.length > 0 ? (
                                    <Button
                                      size="sm"
                                      style={{
                                        padding: "9px",
                                        fontSize: "11px",
                                        backgroundColor: "#e6f4ff",
                                        color: "steelblue",
                                        border: "1px solid #E9ECEF",
                                      }}
                                      onClick={() =>
                                        showCropDetails(landData, index)
                                      }
                                    >
                                      View Crop Details
                                    </Button>
                                  ) : (
                                    ""
                                  )}

                                  {landData.boundary_updated ? (
                                    <>
                                      <Button
                                        size="sm"
                                        style={{
                                          padding: "9px",
                                          fontSize: "11px",
                                          backgroundColor: "rgb(236 254 229)",
                                          color: "green",
                                          border: "1px solid #c7F6B6",
                                        }}
                                        onClick={(e) =>
                                          OpenCropHealth(landData)
                                        }
                                      >
                                        View Crop Health
                                      </Button>

                                      {landData.is_analytics_task_active ? (
                                        <Button
                                          size="sm"
                                          className=""
                                          style={{
                                            padding: "9px",
                                            fontSize: "11px",
                                            backgroundColor: "#e6f4ff",
                                            color: "steelblue",
                                            border: "1px solid transparent",
                                          }}
                                          onClick={() =>
                                            showAnalyticsModal(landData)
                                          }
                                        >
                                          Regenerate ACS
                                        </Button>
                                      ) : (
                                        <Button
                                          size="sm"
                                          className=""
                                          style={{
                                            padding: "9px",
                                            fontSize: "11px",
                                            backgroundColor: "#e6f4ff",
                                            color: "steelblue",
                                            border: "1px solid transparent",
                                          }}
                                          onClick={(e) =>
                                            RegenerateACS(landData)
                                          }
                                        >
                                          Regenerate ACS
                                        </Button>
                                      )}
                                    </>
                                  ) : (
                                    <Button
                                      size="sm"
                                      className="waves-effect waves-light"
                                      style={{
                                        padding: "9px",
                                        fontSize: "11px",
                                        backgroundColor: "#FFFAF0",
                                        border: "1px solid #edd6ab",
                                        color: "orange",
                                      }}
                                      onClick={(e) =>
                                        OpenCreateBoundaryPopup(landData)
                                      }
                                    >
                                      Create Boundary
                                    </Button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center bg-white rounded-3 d-flex justify-content-center py-5 w-100">
                          <h5>No Data Available</h5>
                        </div>
                      )}
                    </div>

                    <Modal
                      show={cropDetailModal}
                      onHide={() => setCropDetailModal(false)}
                      size="xl"
                    >
                      <Modal.Header closeButton>
                        <Modal.Title style={{ color: "" }} className="fw-bold">
                          Crop Detail
                        </Modal.Title>
                      </Modal.Header>

                      <Modal.Body className="p-1">
                        <Card className="border-lg transparent_card">
                          <CardBody className="p-0 p-lg-3">
                            <Col xs="12">
                              <div className="d-flex flex-lg-row flex-md-row flex-wrap d-lg-none d-md-none d-block">
                                {cropList?.crops &&
                                cropList.crops.length > 0 ? (
                                  cropList.crops.map((item, index) => (
                                    <Card
                                      className="transparent_card custom_mb w-100 mb-2"
                                      key={index}
                                      lg="10"
                                      md="5"
                                      xs="12"
                                    >
                                      <CardBody className="p-1 p-lg-3">
                                        <div className="hover-shadow d-lg-none d-md-block d-block rounded-3 bg-white p-3">
                                          <CardTitle className="d-flex align-items-center justify-content-between mb-2">
                                            <div className="d-flex justify-content-between align-items-center w-100">
                                              <span className="font-weight-bold">
                                                <img
                                                  src={item.crop_image}
                                                  style={{
                                                    height: "30px",
                                                    width: "30px",
                                                    borderRadius: "50%",
                                                    objectFit: "contain",
                                                  }}
                                                />
                                                <span className="text-success mx-1 ">
                                                  {item.crop_name || "N/A"}
                                                </span>
                                              </span>
                                              <span className="text-Orange mx-1 d-flex gap-2 lightblack">
                                                <h5>Season: </h5>
                                                <h5>{item.season || "N/A"}</h5>
                                              </span>
                                            </div>
                                          </CardTitle>
                                          <hr
                                            className="mt-0 mb-1"
                                            style={{ borderColor: "#FF8C00" }}
                                          />
                                          <Table className="table mb-0">
                                            <tbody>
                                              <tr>
                                                <th>Crop Year:</th>
                                                <td>{item.year || "N/A"}</td>
                                              </tr>
                                              <tr>
                                                <th>Crop Season:</th>
                                                <td>{item.season || "N/A"}</td>
                                              </tr>
                                              <tr>
                                                <th>Sowing Date:</th>
                                                <td>
                                                  {item.sowing_date || "N/A"}
                                                </td>
                                              </tr>
                                              <tr>
                                                <th>Harvest Date:</th>
                                                <td>
                                                  {item.harvest_date || "N/A"}
                                                </td>
                                              </tr>
                                              <tr>
                                                <th>Income:</th>
                                                <td>{item.income || "N/A"}</td>
                                              </tr>
                                              <tr>
                                                <th>Crop Yield:</th>
                                                <td>
                                                  {item.crop_yield || "N/A"}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </Table>
                                        </div>
                                      </CardBody>
                                    </Card>
                                  ))
                                ) : (
                                  <div className="text-center bg-white rounded-3 d-flex justify-content-center py-5 w-100">
                                    <h5>No Data Available</h5>
                                  </div>
                                )}
                              </div>
                            </Col>
                          </CardBody>
                        </Card>
                      </Modal.Body>
                    </Modal>

                    <Modal
                      show={showCrop}
                      onHide={() => setShowCrop(false)}
                      size="xl"
                    >
                      <Modal.Header closeButton>
                        <Modal.Title style={{ color: "" }} className="fw-bold">
                          Crop Details
                        </Modal.Title>
                      </Modal.Header>

                      <Modal.Body>
                        <div className="d-lg-block d-md-block d-none">
                          <Row className="thm-bg-gray-300 p-2">
                            <div className="table-responsive mb-3">
                              <Table className="table mb-0 w-100">
                                <thead>
                                  <tr>
                                    <th>Crop Image</th>
                                    <th>Crop Name</th>
                                    <th>Crop Year</th>
                                    <th>Crop Season</th>
                                    <th>Sowing Date</th>
                                    <th>Harvest Date</th>
                                    <th>Income</th>
                                    <th>Crop Yield</th>
                                    <th>Edit</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {cropList?.crops?.map((item, index) => {
                                    return (
                                      <tr key={index} className="mt-3">
                                        <td>
                                          <img
                                            src={item.crop_image}
                                            className=""
                                            style={{
                                              height: "60px",
                                              width: "60px",
                                              borderRadius: "3%",
                                              objectFit: "cover",
                                            }}
                                          />
                                        </td>
                                        <td>{item.crop_name}</td>
                                        <td>{item.year}</td>
                                        <td>{item.season}</td>
                                        <td>{item.sowing_date}</td>
                                        <td>{item.harvest_date}</td>
                                        <td>{item.income}</td>
                                        <td>{item.crop_yield}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </div>
                          </Row>
                        </div>
                      </Modal.Body>
                    </Modal>
                    <Modal
                      show={addCrop}
                      onHide={() => setAddCrop(false)}
                      size="xl"
                    >
                      <Modal.Header closeButton>
                        <Modal.Title style={{ color: "" }} className="fw-bold">
                          Add Crop Details
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <form onSubmit={(e) => handleAddCrop(e)}>
                          <Row className="text-gray g-3">
                            <Col lg="3">
                              {!edit ? (
                                <div className="mb-3">
                                  <Label>Select Crop</Label>
                                  <Select
                                    value={
                                      CropCode === null
                                        ? CropCode
                                        : CropCode.label
                                    }
                                    onChange={(CropCode) =>
                                      handleCropCode(
                                        CropCode.value,
                                        CropCode.label,
                                        CropCode.img
                                      )
                                    }
                                    options={optionCrop}
                                    classNamePrefix="select2-selection"
                                  />
                                </div>
                              ) : (
                                <CustomTextField
                                  type="text"
                                  name="crop_name"
                                  className="text-gray form-control"
                                  value={CropLabel}
                                  disabled
                                />
                              )}
                            </Col>

                            <Col lg="3">
                              <CustomTextField
                                type="select"
                                name="season"
                                required
                                className="text-gray form-select"
                                onChange={onInputChange}
                                value={Group.season}
                              >
                                <option value="">Select</option>
                                <option value="Kharif">Kharif</option>
                                <option value="Rabi">Rabi</option>
                                <option value="Zaid">Zaid</option>
                              </CustomTextField>
                            </Col>
                            <Col lg="3">
                              <CustomTextField
                                type="select"
                                name="year"
                                required
                                className="text-gray form-select"
                                onChange={onInputChange}
                                value={Group.year}
                              >
                                <option value="">Select</option>
                                <option value="2025">2025</option>
                                <option value="2024">2024</option>
                                <option value="2023">2023</option>
                                <option value="2022">2022</option>
                                <option value="2021">2021</option>
                              </CustomTextField>
                            </Col>
                            <Col lg="3">
                              <CustomTextField
                                type="text"
                                name="picking_type"
                                required
                                placeholder="Picking Type"
                                className="text-gray form-control"
                                onChange={onInputChange}
                                value={Group.picking_type}
                              />
                            </Col>
                            <Col lg="3">
                              <CustomTextField
                                type="date"
                                name="sowing_date"
                                required
                                className="text-gray form-control"
                                onChange={onInputChange}
                                value={Group.sowing_date}
                              />
                            </Col>
                            <Col lg="3">
                              <CustomTextField
                                type="date"
                                name="harvest_date"
                                required
                                className="text-gray form-control"
                                onChange={onInputChange}
                                value={Group.harvest_date}
                              />
                            </Col>
                            <Col lg="3">
                              <CustomTextField
                                type="text"
                                name="crop_yield"
                                required
                                placeholder="Yield"
                                className="text-gray form-control"
                                onChange={onInputChange}
                                value={Group.crop_yield}
                              />
                            </Col>
                            <Col lg="3">
                              <CustomTextField
                                type="text"
                                name="income"
                                required
                                placeholder="Income"
                                className="text-gray form-control"
                                onChange={onInputChange}
                                value={Group.income}
                              />
                            </Col>
                            {/* <Col lg="3">
    <input type="file" accept=".jpeg, .jpg, .png" name="crop_image" onChange={onInputChange}></input>
   
    </Col> */}
                          </Row>
                          <Button
                            className="submit-btn mt-3 float-end"
                            type="submit"
                          >
                            Submit &nbsp;
                            {loadingg ? <Spinner size="sm" /> : ""}
                          </Button>
                        </form>
                      </Modal.Body>
                    </Modal>

                    <Modal
                      show={openCreateBoundary}
                      onHide={handleClose}
                      size="xl"
                    >
                      <Modal.Header closeButton>
                        <Modal.Title style={{ color: "" }} className="fw-bold">
                          Create Boundary
                        </Modal.Title>
                      </Modal.Header>

                      <Modal.Body>
                        <FarmerCreateBoundary
                          LandList={SendPlotData}
                          refetch={refetch}
                          setCreateBoundary={setCreateBoundary}
                        />
                      </Modal.Body>
                    </Modal>
                  </div>
                  <div className="d-flex flex-lg-row flex-md-row flex-wrap mt-2 d-lg-none d-md-block d-block">
                    {isLoading ? (
                      <CardSkeleton />
                    ) : LandList.length > 0 ? (
                      LandList.map((landData, index) => (
                        <div
                          className="card mb-3 col-lg-3 col-md-6 col-12 shadow-sm rounded-3 "
                          key={index}
                        >
                          <div className="card-body p-3 fpo_card position-relative">
                            {/* <div
                              className="rounded-2"
                              style={{ height: "200px", overflow: "hidden" }}
                            >
                              <FarmerCropHealthMap
                                boundary={landData?.boundary}
                              />
                            </div> */}

                            <div className="d-flex flex-column gap-2 mt-2">
                              {/* ACS */}
                              <div className="d-flex justify-content-between">
                                <h6 style={{ color: "#5c5c5cb3" }}>ACS:</h6>
                                <span>{landData.ACS || "N/A"}</span>
                              </div>
                              {/* Survey Number */}
                              <div className="d-flex justify-content-between">
                                <h6 style={{ color: "#5c5c5cb3" }}>
                                  Survey N.:
                                </h6>
                                <span>{landData.survey_number || "N/A"}</span>
                              </div>
                              {/* Declared Area */}
                              <div className="d-flex justify-content-between">
                                <h6 style={{ color: "#5c5c5cb3" }}>
                                  Declared Area:
                                </h6>
                                <span>{landData.declared_area || "N/A"}</span>
                              </div>
                              {/* Calculated Area */}
                              <div className="d-flex justify-content-between">
                                <h6 style={{ color: "#5c5c5cb3" }}>
                                  Calculated Area:
                                </h6>
                                <span>{landData.calculated_area || "N/A"}</span>
                              </div>
                              {/* Irrigation Source */}
                              <div className="d-flex justify-content-between">
                                <h6 style={{ color: "#5c5c5cb3" }}>
                                  Irrigation Source:
                                </h6>
                                <span>
                                  {landData.irrigation_source || "N/A"}
                                </span>
                              </div>
                              {/* Analytics Status */}
                              <div className="d-flex justify-content-between">
                                <h6 style={{ color: "#5c5c5cb3" }}>
                                  Analytics Status:
                                </h6>

                                <Tag
                                  bordered={false}
                                  style={{ fontWeight: "500" }}
                                  color="geekblue"
                                >
                                  {landData.analytics_task_status || "N/A"}
                                </Tag>
                              </div>
                              <div className="d-flex justify-content-between mt-2">
                                <Button
                                  size="sm"
                                  style={{
                                    padding: "9px",
                                    fontSize: "11px",
                                    backgroundColor: "#e6f4ff",
                                    color: "steelblue",
                                    border: "1px solid #E9ECEF",
                                  }}
                                  onClick={() =>
                                    showCropDetails(landData, "mobile")
                                  }
                                >
                                  View Crop Details
                                </Button>

                                {landData.boundary_updated ? (
                                  <>
                                    <Button
                                      size="sm"
                                      style={{
                                        padding: "9px",
                                        fontSize: "11px",
                                        backgroundColor: "rgb(236 254 229)",
                                        color: "green",
                                        border: "1px solid #c7F6B6",
                                      }}
                                      onClick={(e) =>
                                        OpenCropHealth(landData, "mobile")
                                      }
                                    >
                                      View Crop Health
                                    </Button>

                                    {landData.is_analytics_task_active ? (
                                      <Button
                                        size="sm"
                                        className=""
                                        style={{
                                          padding: "9px",
                                          fontSize: "11px",
                                          backgroundColor: "#e6f4ff",
                                          color: "steelblue",
                                          border: "1px solid transparent",
                                        }}
                                        onClick={() =>
                                          showAnalyticsModal(landData)
                                        }
                                      >
                                        Regenerate ACS
                                      </Button>
                                    ) : (
                                      <Button
                                        size="sm"
                                        className=""
                                        style={{
                                          padding: "9px",
                                          fontSize: "11px",
                                          backgroundColor: "#e6f4ff",
                                          color: "steelblue",
                                          border: "1px solid transparent",
                                        }}
                                        onClick={(e) => RegenerateACS(landData)}
                                      >
                                        Regenerate ACS
                                      </Button>
                                    )}
                                  </>
                                ) : (
                                  <Button
                                    size="sm"
                                    className="waves-effect waves-light"
                                    style={{
                                      padding: "9px",
                                      fontSize: "11px",
                                      backgroundColor: "#FFFAF0",
                                      border: "1px solid #edd6ab",
                                      color: "orange",
                                    }}
                                    onClick={(e) =>
                                      OpenCreateBoundaryPopup(landData)
                                    }
                                  >
                                    Create Boundary
                                  </Button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-center bg-white rounded-3 d-flex justify-content-center py-5 w-100">
                        <h5>No Data Available</h5>
                      </div>
                    )}
                  </div>
                </>
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal
        show={cropHealthModal}
        onHide={() => setCropHealthModal(false)}
        size={modaltype === "mobile " ? "xm" : "xl"}
        className="farmer_modal"
      >
        {/* <Modal.Header closeButton>
          <div
            className="d-flex justify-content-between"
            style={{ width: "100%" }}
          >
            <h4 className="fw-bold text-black m-0">
              Farm Report : {plotDetails?.plot_name}{" "}
            </h4>
            
            <div className="d-flex justify-content-between align-items-center flex-wrap my-3 gap-2 d-lg-block d-md-block d-none">
  <div className="d-flex gap-4 flex-wrap">
    <div className="d-flex align-items-center">
      <input
        type="radio"
        name="reportType"
        id="completeReport"
        value="completeReport"
        checked={activeCard === "completeReport"}
        className="form-check-input"
        onChange={() => setActiveCard("completeReport")}
      />
      <label className="form-check-label mb-0 mx-2" htmlFor="completeReport">
        Complete Report
      </label>
    </div>

    <div className="d-flex align-items-center">
      <input
        type="radio"
        name="reportType"
        id="historicalReport"
        value="historicalReport"
        checked={activeCard === "historicalReport"}
        className="form-check-input"
        onChange={() => setActiveCard("historicalReport")}
      />
      <label className="form-check-label mb-0 mx-2" htmlFor="historicalReport">
        Historical Report
      </label>
    </div>

    <div className="d-flex align-items-center">
      <input
        type="radio"
        name="reportType"
        id="currentReport"
        value="currentReport"
        checked={activeCard === "currentReport"}
        className="form-check-input"
        onChange={() => setActiveCard("currentReport")}
      />
      <label className="form-check-label mb-0 mx-2" htmlFor="currentReport">
        Current Report
      </label>
    </div>
  </div>

  <Button
    onClick={handleDownloadPDF}
    className="buttonGreenDefaultColor btn-sm mt-2 mt-md-0"
  >
    {loadingg ? (
      <>
        <Spinner animation="border" size="sm" className="me-2" />
        Generating...
      </>
    ) : (
      <>
        Download Report <i className="mdi mdi-download"></i>
      </>
    )}
  </Button>
</div> 
          </div>
        </Modal.Header> */}
        <Modal.Header closeButton>
          <div
            className="d-flex align-items-center justify-content-between w-100 flex-wrap"
            style={{ gap: "12px" }}
          >
            <h4 className="fw-bold text-black m-0">
              Farm Report : {plotDetails?.plot_name}
            </h4>

            <div className="d-flex align-items-center gap-3 flex-wrap">
              <div className="d-flex align-items-center gap-4 flex-wrap">
                <div className="d-flex align-items-center">
                  <input
                    type="radio"
                    name="reportType"
                    id="completeReport"
                    value="completeReport"
                    checked={activeCard === "completeReport"}
                    className="form-check-input"
                    onChange={() => setActiveCard("completeReport")}
                  />
                  <label
                    className="form-check-label mb-0 mx-2"
                    htmlFor="completeReport"
                  >
                    Complete Report
                  </label>
                </div>

                <div className="d-flex align-items-center">
                  <input
                    type="radio"
                    name="reportType"
                    id="historicalReport"
                    value="historicalReport"
                    checked={activeCard === "historicalReport"}
                    className="form-check-input"
                    onChange={() => setActiveCard("historicalReport")}
                  />
                  <label
                    className="form-check-label mb-0 mx-2"
                    htmlFor="historicalReport"
                  >
                    Historical Report
                  </label>
                </div>

                <div className="d-flex align-items-center">
                  <input
                    type="radio"
                    name="reportType"
                    id="currentReport"
                    value="currentReport"
                    checked={activeCard === "currentReport"}
                    className="form-check-input"
                    onChange={() => setActiveCard("currentReport")}
                  />
                  <label
                    className="form-check-label mb-0 mx-2"
                    htmlFor="currentReport"
                  >
                    Current Report
                  </label>
                </div>
              </div>

              <Button
                onClick={handleDownloadPDF}
                className="buttonGreenDefaultColor btn-sm"
              >
                {loadingg ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Generating...
                  </>
                ) : (
                  <>
                    Download Report <i className="mdi mdi-download"></i>
                  </>
                )}
              </Button>
            </div>
          </div>
        </Modal.Header>

        {/* <Modal.Body className="p-0" ref={mapRef}> */}
        <Modal.Body className="p-0" ref={mapRef}>
          <FarmerCropDynamicData
            SendPlotData={plotDetails}
            allData={allData}
            RoleAcessParams={RoleAcessParams}
            activeCard={activeCard}
            id={idd}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="editDetails"
            type=""
            className="btn btn-danger waves-effect me-2 fs-6"
            onClick={() => setCropHealthModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={analyticsmodal} onHide={handleCloseAnalytics} size="xm">
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">Analytics Requested</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <h5 className="text-center mt-3">
            Your Request for analytics is in progress and{" "}
            <b> Current Status </b> is{" "}
            <span className="text-danger">{currentStatus}</span>.
          </h5>
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="editDetails"
            type=""
            className="btn btn-danger waves-effect me-2 fs-6"
            onClick={handleCloseAnalytics}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
};

export default FarmerDetailsLand;
